import { formattedDate } from '@/utils/utils'
import jwtDecode from 'jwt-decode'
import Quasar from 'quasar'
import Vue from 'vue'
import { RecycleScroller } from 'vue-virtual-scroller'
import App from './App.vue'
import AdminSign from './components/common/AdminSign.vue'
import DeploymentDot from './components/common/DeploymentDot.vue'
import FreezePeriodBanner from './components/common/FreezePeriodBanner.vue'
import JsonInput from './components/common/JsonInput.vue'
import TestInput from './components/common/TestInput.vue'
import TestResultIcon from './components/common/TestResultIcon.vue'
import UserValues from './components/common/UserValues.vue'
import WarningBanner from './components/common/WarningBanner.vue'
import WarningDialog from './components/common/WarningDialog.vue'
import { AUTH_SSO_URL } from './config'
import { isProduction } from './environment'
import { createRouter } from './router'
import { addErrorHandlers } from './utils/addErrorHandlers'
import { store } from './vuex'

import '@quasar/extras/fontawesome-v5/fontawesome-v5.css'
import '@quasar/extras/material-icons/material-icons.css'
import 'vue-virtual-scroller/dist/vue-virtual-scroller.css'
import './styles/main.scss'

Vue.config.productionTip = isProduction

Vue.use(Quasar, {
  config: {
    loadingBar: {
      skipHijack: true,
    },
  },
})

Vue.component('RecycleScroller', RecycleScroller as any)

if (AUTH_SSO_URL && window.location.pathname === '/auth') {
  window.location.href = AUTH_SSO_URL
}

// Register our common components globally
Vue.component('TestResultIcon', TestResultIcon)
Vue.component('JsonInput', JsonInput)
Vue.component('TestInput', TestInput)
Vue.component('UserValues', UserValues)
Vue.component('DeploymentDot', DeploymentDot)
Vue.component('WarningDialog', WarningDialog)
Vue.component('AdminSign', AdminSign)
Vue.component('WarningBanner', WarningBanner)
Vue.component('FreezePeriodBanner', FreezePeriodBanner)

new Vue({
  router: createRouter(store.original),
  store: store.original,
  render: h => h(App),
}).$mount('#app')

Vue.filter('formattedDate', (value: string) => formattedDate(value))

addErrorHandlers(window, Vue, store)

document.addEventListener('visibilitychange', () => {
  if (!document.hidden) {
    // Refresh expired auth token immediately when tab becomes active
    const hasRefreshToken = !!localStorage.getItem('refresh_token')
    const token = localStorage.getItem('token')

    if (token && hasRefreshToken) {
      const { exp } = jwtDecode<{ exp: number }>(token)
      const isExpiredOrAboutToExpire = exp * 1000 < Date.now() + 60 * 1000
      if (isExpiredOrAboutToExpire) {
        store.dispatch.auth.REFRESH_AUTH_TOKEN()
      }
    }
  }
})
